export default __webpack_public_path__ + "static/media/May2009.ef3812e9.png";